import { DefaultValues, MODULE_NAMES } from '@maporium-workspace/shared';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { isEqual } from 'lodash';
import { debounceTime, distinctUntilChanged, filter, Subscription } from 'rxjs';

const INFORMATION_FIELDS = new Set(['name', 'description', 'metadata']);

export abstract class SidebarFormAbstractComponent<T> {
  abstract formGroup: FormGroup;
  protected readonly MODULE_NAMES = MODULE_NAMES;
  protected readonly DefaultValues = DefaultValues;
  protected debounceTime = 500;
  protected isPatchingForm = false;

  init() {
    this.formGroup.valueChanges
      .pipe(
        filter(() => !this.isPatchingForm),
        debounceTime(this.debounceTime),
        distinctUntilChanged((prev, curr) => isEqual(prev, curr))
      )
      .subscribe((form) => {
        this.update();
      });
  }

  protected watchStyleTouches(onTouch: (path: string, value: unknown) => void): Subscription {
    const subscription = new Subscription();
    const walk = (control: AbstractControl, path: string) => {
      if (control instanceof FormGroup) {
        Object.entries(control.controls).forEach(([key, child]) => {
          if (!path && INFORMATION_FIELDS.has(key)) return;
          walk(child, path ? `${path}.${key}` : key);
        });
        return;
      }
      subscription.add(
        control.valueChanges
          .pipe(filter(() => !this.isPatchingForm))
          .subscribe((value) => onTouch(path, value)),
      );
    };
    walk(this.formGroup, '');
    return subscription;
  }

  get metadataControl(): FormControl {
    return this.formGroup.get('metadata') as FormControl;
  }


  abstract selectNameInput(): void;

  abstract patchForm(model: T): void;

  abstract resetState(): void;

  // Use it to update the data , use for call emit on output
  abstract update(): void;
}
